import { patchState, signalStoreFeature, type, withMethods } from "@ngrx/signals";
import { IUserProfileState } from "./user-profile.state";
import { UserProfile } from "../../models/user-profile/user-profile.model";
import { encryptToStorage, decryptFromStorage } from "../../utils/storage-encryption.util";

export const USER_PROFILE_STORAGE_KEY = 'caremo_user_profile';

export const withUserProfileStateMethods = signalStoreFeature(
    { state: type<IUserProfileState>() },
    withMethods((store) => ({
        setUserProfile: (userProfile: UserProfile) => {
            localStorage.setItem(USER_PROFILE_STORAGE_KEY, encryptToStorage(userProfile));
            patchState(store, { userProfile, loading: false, error: null });
        },
        clearUserProfile: () => {
            localStorage.removeItem(USER_PROFILE_STORAGE_KEY);
            patchState(store, { userProfile: null, loading: false, error: null });
        },
        setError: (error: string) => {
            patchState(store, { error, loading: false });
        },
        setEmailVerified: (isEmailVerified: boolean) => {
            const current = store.userProfile();
            if (!current) return;
            const updated = { ...current, isEmailVerified };
            localStorage.setItem(USER_PROFILE_STORAGE_KEY, encryptToStorage(updated));
            patchState(store, { userProfile: updated });
        },
        rehydrateFromStorage: () => {
            const raw = localStorage.getItem(USER_PROFILE_STORAGE_KEY);
            if (raw) {
                const userProfile = decryptFromStorage<UserProfile>(raw);
                if (userProfile) {
                    patchState(store, { userProfile, loading: false, error: null });
                }
            }
        }
    }))
);
